import React from "react";
import { Typography } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import SbTooltip from "uiCore/SbTooltip/SbTooltip";
import {
  PageHeaderStyled,
  HeaderLeftStyled,
  HeaderRightStyled,
  HeadingRowStyled,
} from "styles/common.styles";
import { BackButtonStyled, PageHeaderGridStyled } from "./PageHeader.styles";

const { Title, Text } = Typography;

// Standard landing-page header (spec taken from the Jobs Library landing page).
// Typography, spacing and placement are fixed here on purpose: callers pass
// content only, so every module header stays identical.
//   title      - page title (always rendered as Title level 3)
//   titleExtra - inline content next to the title (view toggle, refresh button)
//   subtitle   - string/node, or an array of lines (strings get secondary text;
//                elements are rendered as-is)
//   middle     - optional centre slot between title block and actions (score gauge)
//   gridLayout - optional; fixed 3-column grid with wide gutters (use with middle)
//   actions    - right-hand slot (search, buttons)
//   onBack     - optional; renders the standard back button before the title
//   backLabel  - tooltip + accessible name for that button (default "Go back")
//   headingRef - optional ref on the title row (guided-tour spotlight target)
const PageHeader = ({ title, titleExtra, subtitle, actions, middle, gridLayout = false, onBack, backLabel = "Go back", headingRef }) => {
  const subtitleLines = Array.isArray(subtitle) ? subtitle : [subtitle];

  const Wrapper = gridLayout ? PageHeaderGridStyled : PageHeaderStyled;

  return (
    <Wrapper>
      <HeaderLeftStyled>
        <HeadingRowStyled ref={headingRef}>
          {onBack && (
            <SbTooltip content={backLabel}>
              <BackButtonStyled icon={<ArrowLeftOutlined />} onClick={onBack} aria-label={backLabel} />
            </SbTooltip>
          )}
          <Title level={3}>{title}</Title>
          {titleExtra}
        </HeadingRowStyled>
        {subtitleLines.filter(Boolean).map((line, index) =>
          typeof line === "string" ? (
            // Index key: the lines are static, and identical strings must not collide.
            <Text type="secondary" key={index}>
              {line}
            </Text>
          ) : (
            // Elements (e.g. an expandable Paragraph) are rendered as given.
            <React.Fragment key={index}>{line}</React.Fragment>
          )
        )}
      </HeaderLeftStyled>
      {middle && <div>{middle}</div>}
      {actions && <HeaderRightStyled>{actions}</HeaderRightStyled>}
    </Wrapper>
  );
};

export default PageHeader;
